export var TypeOfGateChannel;
(function (TypeOfGateChannel) {
    TypeOfGateChannel[TypeOfGateChannel["Gate"] = 1] = "Gate";
    TypeOfGateChannel[TypeOfGateChannel["Gateway"] = 2] = "Gateway";
    TypeOfGateChannel[TypeOfGateChannel["Monostable"] = 3] = "Monostable";
})(TypeOfGateChannel || (TypeOfGateChannel = {}));
export var LimitSwitchFunction;
(function (LimitSwitchFunction) {
    LimitSwitchFunction[LimitSwitchFunction["LimitSwitchDisabled"] = 0] = "LimitSwitchDisabled";
    LimitSwitchFunction[LimitSwitchFunction["LimitSwitchClosed"] = 1] = "LimitSwitchClosed";
    LimitSwitchFunction[LimitSwitchFunction["LimitSwitchOpened"] = 2] = "LimitSwitchOpened";
})(LimitSwitchFunction || (LimitSwitchFunction = {}));
export var LimitSwitchType;
(function (LimitSwitchType) {
    LimitSwitchType[LimitSwitchType["NormallyOpened"] = 1] = "NormallyOpened";
    LimitSwitchType[LimitSwitchType["NormallyClosed"] = 2] = "NormallyClosed";
})(LimitSwitchType || (LimitSwitchType = {}));
export class LimitSwitchConfiguration {
    constructor() {
        this.Channel = 0;
        this.Input = 0;
        this.Function = LimitSwitchFunction.LimitSwitchDisabled;
        this.Type = LimitSwitchType.NormallyClosed;
    }
}
//# sourceMappingURL=Rob21ConfigParams.js.map